<template>
  <div class="mb-40">
    <AlertDialog :open="showSucessModal" @update:open="(o) => !o && (showSucessModal = false)">
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{{ sucessMessage }}</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction @click="showSucessModal = false">OK</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>

    <!--NAME FORM-->
    <AlertDialog
      :open="showNameForm"
      @update:open="(o) => { if (!o) { showNameForm = false; userUpdateRequest.firstName = userDetails.firstName; userUpdateRequest.lastName = userDetails.lastName } }"
    >
      <AlertDialogContent class="max-w-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle>Update your details</AlertDialogTitle>
          <AlertDialogDescription>Update your fist name, last name and content settings</AlertDialogDescription>
        </AlertDialogHeader>
        <div class="space-y-3">
          <Input
            class="w-full"
            v-model="userUpdateRequest.firstName"
            type="text"
            placeholder="First Name"
          />
          <Input
            class="w-full"
            v-model="userUpdateRequest.lastName"
            type="text"
            placeholder="Last Name"
          />
          <div>
            <label class="text-sm font-medium" for="content-notifications">Receive content notifications</label>
            <Select v-model="contentNotificationsStr">
              <SelectTrigger id="content-notifications" class="w-full">
                <SelectValue placeholder="Receive content notifications" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem v-for="o in trueOrFalse" :key="String(o.id)" :value="String(o.id)">{{ o.text }}</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <label class="text-sm font-medium" for="webhook-notifications">Receive webhook notifications</label>
            <Select v-model="webhookNotificationsStr">
              <SelectTrigger id="webhook-notifications" class="w-full">
                <SelectValue placeholder="Receive webhook notifications" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem v-for="o in trueOrFalse" :key="String(o.id)" :value="String(o.id)">{{ o.text }}</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Alert v-if="userUpdateRequestFormError" variant="destructive">
            <AlertDescription>{{ userUpdateRequestFormError }}</AlertDescription>
          </Alert>
        </div>
        <AlertDialogFooter class="gap-2">
          <AlertDialogCancel @click="() => { showNameForm = false; userUpdateRequest.firstName = userDetails.firstName; userUpdateRequest.lastName = userDetails.lastName }">Cancel</AlertDialogCancel>
          <AlertDialogAction :disabled="!validateUserDetails" @click="updateUserDetails()">Save changes</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
    <!--PASSWORD FORM-->
    <AlertDialog :open="showPasswordForm" @update:open="(o) => !o && (showPasswordForm = false)">
      <AlertDialogContent class="max-w-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle>Set a new password</AlertDialogTitle>
          <AlertDialogDescription>Create and replace your old password</AlertDialogDescription>
        </AlertDialogHeader>
        <div class="space-y-3">
          <Alert v-if="userUpdatePasswordRequestError" variant="destructive">
            <AlertDescription>{{ userUpdatePasswordRequestError }}</AlertDescription>
          </Alert>
          <Input
            class="w-full"
            v-model="userUpdatePasswordRequest.currentPassword"
            type="password"
            placeholder="Current password"
          />
          <Input
            class="w-full"
            v-model="userUpdatePasswordRequest.newPassword"
            type="password"
            placeholder="New password"
          />
          <Input
            class="w-full"
            v-model="confirmPassword"
            type="password"
            placeholder="Confirm password"
          />

          <div class="text-muted-foreground text-sm">
            <h2 class="font-medium">Password requirements</h2>
            <p>Please follow this guide for a strong password</p>
            <p :class="emailStrong.special ? 'text-blue-600 font-medium' : 'text-muted-foreground'">
              - One special character
            </p>
            <p :class="emailStrong.length ? 'text-blue-600 font-medium' : 'text-muted-foreground'">
              - Min 8 characters
            </p>
            <p :class="emailStrong.number ? 'text-blue-600 font-medium' : 'text-muted-foreground'">
              - One number (2 recommended)
            </p>
            <p :class="emailStrong.capital ? 'text-blue-600 font-medium' : 'text-muted-foreground'">
              - One capital
            </p>
            <p :class="matching ? 'text-blue-600 font-medium' : 'text-muted-foreground'">- Matching</p>
          </div>
        </div>
        <AlertDialogFooter class="gap-2">
          <AlertDialogCancel @click="showPasswordForm = false">Cancel</AlertDialogCancel>
          <AlertDialogAction :disabled="!matching" @click="updateUserPassword()">Save changes</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
    <!--INVITE NEW USER FORM-->
    <Drawer
      direction="right"
      :open="showInviteUserForm"
      @update:open="(o) => !o && (showInviteUserForm = false)"
    >
      <DrawerContent class="sm:max-w-md">
        <DrawerHeader class="text-left">
          <DrawerTitle>Invite a new user</DrawerTitle>
          <DrawerDescription>Send an email invite to a team member</DrawerDescription>
        </DrawerHeader>
        <div class="flex flex-col gap-3 overflow-y-auto px-4 flex-1">
          <Alert v-if="userInviteRequestFormError" variant="destructive">
            <AlertDescription>{{ userInviteRequestFormError }}</AlertDescription>
          </Alert>
          <div class="grid gap-1.5">
            <label class="text-sm font-medium" for="invite-email">Email</label>
            <Input
              id="invite-email"
              v-model="inviteUserRequest.email"
              type="email"
              placeholder="name@company.com"
            />
          </div>
        </div>
        <DrawerFooter class="flex-row justify-end gap-2">
          <Button variant="outline" @click="showInviteUserForm = false">Cancel</Button>
          <Button :disabled="!validInviteUser" @click="handleInviteUser()">Send invite</Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>

    <!--REVOKE INVITE CONFIRM-->
    <AlertDialog :open="showRevokeConfirm" @update:open="(o) => !o && (showRevokeConfirm = false)">
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Revoke invite?</AlertDialogTitle>
          <AlertDialogDescription>
            This will cancel the pending invite for
            <span class="font-medium text-foreground">{{ revokeTarget?.email }}</span>. Their invite
            link will stop working. This can't be undone, but you can send a new invite later.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter class="gap-2">
          <AlertDialogCancel @click="showRevokeConfirm = false">Cancel</AlertDialogCancel>
          <AlertDialogAction
            class="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            @click="handleRevokeConfirm()"
          >
            Revoke invite
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>

    <Card class="mb-4">
      <CardHeader>
        <CardTitle>Profile</CardTitle>
        <CardDescription>Your personal details and notification preferences.</CardDescription>
        <CardAction class="flex items-center gap-2">
          <Button size="sm" @click="showNameForm = true"><Pencil class="w-4 h-4" />Edit profile</Button>
          <Button size="sm" @click="showPasswordForm = true"><Key class="w-4 h-4" />Change password</Button>
        </CardAction>
      </CardHeader>
      <CardContent>
        <dl class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
          <div>
            <dt class="text-xs uppercase tracking-wide text-muted-foreground mb-1">First name</dt>
            <dd class="text-sm font-medium">{{ userDetails.firstName || '—' }}</dd>
          </div>
          <div>
            <dt class="text-xs uppercase tracking-wide text-muted-foreground mb-1">Last name</dt>
            <dd class="text-sm font-medium">{{ userDetails.lastName || '—' }}</dd>
          </div>
          <div>
            <dt class="text-xs uppercase tracking-wide text-muted-foreground mb-1">Content notifications</dt>
            <dd>
              <Badge :variant="userDetails.sendContentNotifications == 'true' ? 'default' : 'secondary'">
                {{ userDetails.sendContentNotifications == 'true' ? 'Enabled' : 'Disabled' }}
              </Badge>
            </dd>
          </div>
          <div>
            <dt class="text-xs uppercase tracking-wide text-muted-foreground mb-1">Webhook notifications</dt>
            <dd>
              <Badge :variant="userDetails.sendWebhookNotifications == 'true' ? 'default' : 'secondary'">
                {{ userDetails.sendWebhookNotifications == 'true' ? 'Enabled' : 'Disabled' }}
              </Badge>
            </dd>
          </div>
        </dl>
      </CardContent>
    </Card>

    <Card>
      <CardHeader>
        <CardTitle>Team members</CardTitle>
        <CardDescription>Invite and manage users who can access your dashboard.</CardDescription>
        <CardAction>
          <Button size="sm" @click="showInviteUserForm = true"><UserPlus class="w-4 h-4" />Invite user</Button>
        </CardAction>
      </CardHeader>
      <CardContent>
        <DataTable
          :headers="userHeaders"
          :items="publisherUsers"
          :loading="loading"
          :error="error"
          @retry="getPublisherUsers(serverOptions.page - 1, serverOptions.rowsPerPage)"
          v-model:server-options="serverOptions"
          :server-items-length="serverItemsLength"
          :filter-groups="filterGroups"
          :filters="filters"
          @filter-change="onFilterChange"
        >
          <template #item-name="val">
            <div class="flex items-center gap-2">
              <Avatar size="sm">
                <AvatarFallback>{{ memberInitials(val) }}</AvatarFallback>
              </Avatar>
              <div class="min-w-0">
                <p v-if="val.firstName || val.lastName" class="text-sm font-medium truncate">
                  {{ val.firstName }} {{ val.lastName }}
                </p>
                <p v-else class="text-sm text-muted-foreground italic">Pending sign-up</p>
                <p class="text-xs text-muted-foreground truncate">{{ val.email }}</p>
              </div>
            </div>
          </template>
          <template #item-publisherUserRole="val">
            <Badge variant="secondary">{{ val.publisherUserRole }}</Badge>
          </template>
          <template #item-status="val">
            <Badge :variant="statusVariant(val.status)">{{ statusLabel(val.status) }}</Badge>
          </template>
          <template #item-action="val">
            <div class="flex justify-end items-center gap-1">
              <!-- Invited row -->
              <Button
                v-if="val.status === 'INVITED'"
                size="sm"
                variant="destructive"
                @click="confirmRevoke(val)"
              >
                <Trash2 class="w-4 h-4" />Revoke invite
              </Button>

              <!-- Existing user rows -->
              <template v-else>
                <Button size="sm" @click="resetPassword(val.id)">
                  <SendHorizontal class="w-4 h-4" />Reset link
                </Button>
                <Button
                  v-if="val.status === 'ACTIVE'"
                  size="sm"
                  variant="destructive"
                  @click="deactivateUser(val.id)"
                >
                  <UserX class="w-4 h-4" />Deactivate
                </Button>
                <Button
                  v-else-if="val.status === 'DEACTIVATED'"
                  size="sm"
                  variant="outline"
                  @click="activateUser(val.id)"
                >
                  <UserCheck class="w-4 h-4" />Reactivate
                </Button>
                <Button
                  v-if="
                    (val.publisherUserRole == 'ADMIN' && adminCount > 1) ||
                    val.publisherUserRole == 'USER'
                  "
                  size="sm"
                  variant="destructive"
                  @click="deleteUser(val.id)"
                >
                  <Trash2 class="w-4 h-4" />
                </Button>
              </template>
            </div>
          </template>
        </DataTable>
      </CardContent>
    </Card>
  </div>
</template>

<script>
import {
  Card, CardHeader, CardTitle, CardDescription, CardContent, CardAction,
  Button,
  Input,
  Alert, AlertDescription,
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogAction, AlertDialogCancel,
  Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription, DrawerFooter,
  Avatar, AvatarFallback,
  Badge,
  Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from '@boogi/ui'
import { toast } from '@boogi/ui'
import { Pencil, Key, UserPlus, SendHorizontal, Trash2, UserX, UserCheck } from 'lucide-vue-next'
import { DataTable } from '@boogi/ui'

export default {
  name: 'Settings-page',
  components: {
    DataTable,
    Card, CardHeader, CardTitle, CardDescription, CardContent, CardAction,
    Button,
    Input,
    Alert, AlertDescription,
    AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogAction, AlertDialogCancel,
    Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription, DrawerFooter,
    Avatar, AvatarFallback,
    Badge,
    Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
    Pencil, Key, UserPlus, SendHorizontal, Trash2, UserX, UserCheck,
  },
  data() {
    return {
      showNameForm: false,
      showPasswordForm: false,
      showInviteUserForm: false,
      showRevokeConfirm: false,
      revokeTarget: null,
      loading: true,
      error: false,
      publisher: localStorage.getItem('publisher'),
      showSucessModal: false,
      sucessMessage: '',

      userDetails: {
        firstName: localStorage.getItem('firstName'),
        lastName: localStorage.getItem('lastName'),
        sendContentNotifications: localStorage.getItem('sendContentNotifications'),
        sendWebhookNotifications: localStorage.getItem('sendWebhookNotifications'),
      },

      trueOrFalse: [
        { id: true, text: 'Yes' },
        { id: false, text: 'No' },
      ],

      userUpdateRequest: {
        firstName: localStorage.getItem('firstName'),
        lastName: localStorage.getItem('lastName'),
        contentNotifications: localStorage.getItem('sendContentNotifications'),
        webhookNotifications: localStorage.getItem('sendWebhookNotifications'),
      },
      userUpdatePasswordRequest: {
        currentPassword: '',
        newPassword: '',
      },
      confirmPassword: '',
      inviteUserRequest: {
        email: '',
        publisherId: '',
      },

      userUpdatePasswordRequestError: '',
      userUpdateRequestFormError: '',
      userInviteRequestFormError: '',

      emailStrong: {
        special: false,
        length: false,
        number: false,
        capital: false,
      },
      errors: {
        firstName: '',
        lastName: '',
      },

      userData: {},

      userHeaders: [
        { text: 'Member', value: 'name' },
        { text: 'Role', value: 'publisherUserRole' },
        { text: 'Status', value: 'status' },
        { text: 'Action', value: 'action' },
      ],
      publisherUsers: [],

      serverOptions: { page: 1, rowsPerPage: 25 },
      serverItemsLength: undefined,
      filterGroups: [
        {
          key: 'status',
          label: 'Status',
          options: [
            { label: 'Active', value: 'ACTIVE' },
            { label: 'Deactivated', value: 'DEACTIVATED' },
            { label: 'Invited', value: 'INVITED' },
          ],
        },
      ],
      filters: { status: [] },
    }
  },
  mounted() {
    this.getPublisherUsers(0, this.serverOptions.rowsPerPage)
    this.getUser()
    document.title = 'Settings'
  },
  computed: {
    contentNotificationsStr: {
      get() {
        return String(this.userUpdateRequest.contentNotifications)
      },
      set(value) {
        this.userUpdateRequest.contentNotifications = value
      },
    },
    webhookNotificationsStr: {
      get() {
        return String(this.userUpdateRequest.webhookNotifications)
      },
      set(value) {
        this.userUpdateRequest.webhookNotifications = value
      },
    },
    matching() {
      return (
        this.userUpdatePasswordRequest.newPassword === this.confirmPassword &&
        this.userUpdatePasswordRequest.currentPassword != '' &&
        this.userUpdatePasswordRequest.newPassword != ''
      )
    },
    secure() {
      return (
        this.emailStrong.length &&
        this.emailStrong.special &&
        this.emailStrong.number &&
        this.emailStrong.capital
      )
    },
    validateUserDetails() {
      return !(this.userUpdateRequest.firstName == '' || this.userUpdateRequest.lastName == '')
    },
    validInviteUser() {
      const mailRegex =
        /^(([^<>()[\]\\^.,;:`{}?!|~\s@"]+(\.[^<>()[\]\\^.,;:`{}?!|~\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (mailRegex.test(this.inviteUserRequest.email)) {
        return true
      } else return false
    },
    adminCount() {
      return this.publisherUsers.filter(
        (u) => u.publisherUserRole === 'ADMIN' && u.type === 'USER'
      ).length
    },
  },
  watch: {
    serverOptions: {
      deep: true,
      handler(val) {
        this.getPublisherUsers(val.page - 1, val.rowsPerPage)
      },
    },
    userUpdateRequest: {
      deep: true,
      handler: function (val) {
        if (val.firstName == '') {
          this.errors.firstName = "This can't be empty"
        } else {
          this.errors.firstName = ''
        }
        if (val.lastName == '') {
          this.errors.lastName = "This can't be empty"
        } else {
          this.errors.lastName = ''
        }
      },
    },

    userUpdatePasswordRequest: {
      deep: true,
      handler: function (val) {
        if (val.newPassword.match(/^(?=.*[A-Z])/)) {
          this.emailStrong.capital = true
        } else {
          this.emailStrong.capital = false
        }
        if (val.newPassword.match(/^(?=.*[0-9])/)) {
          this.emailStrong.number = true
        } else {
          this.emailStrong.number = false
        }
        if (val.newPassword.match(/^(?=.*[!@#$%^&*-])/)) {
          this.emailStrong.special = true
        } else {
          this.emailStrong.special = false
        }
        if (val.newPassword.match(/^(?=.{8,})/)) {
          this.emailStrong.length = true
        } else {
          this.emailStrong.length = false
        }
      },
    },
  },
  methods: {
    async resetPassword(userId) {
      try {
        const token = localStorage.getItem('token')
        const response = await this.$apiFetch(
          `${localStorage.getItem('apiUrl')}/private/api/client/publisher/user/${userId}/reset`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `${token}`,
            },
          }
        )

        if (response.ok) {
          this.showResetSuccessModal = true
        } else {
          this.userUpdatePasswordRequestError = 'Current password is incorrect'
        }
      } catch (e) {
        console.error(e)
        this.userUpdatePasswordRequestError = 'Current password is incorrect'
      }
    },

    async deleteUser(userId) {
      try {
        const token = localStorage.getItem('token')
        const response = await this.$apiFetch(
          `${localStorage.getItem('apiUrl')}/private/api/client/publisher/user/${userId}/delete`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `${token}`,
            },
          }
        )

        if (response.ok) {
          this.getPublisherUsers(this.serverOptions.page - 1, this.serverOptions.rowsPerPage)
        } else {
          this.showErrorModal = true
        }
      } catch (e) {
        console.error(e)
        this.showErrorModal = true
      }
    },

    async updateUserDetails() {
      try {
        const token = localStorage.getItem('token')

        const response = await this.$apiFetch(
          `${localStorage.getItem('apiUrl')}/private/api/client/user/update/details`,
          {
            method: 'POST',
            body: JSON.stringify(this.userUpdateRequest),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `${token}`,
            },
          }
        )

        if (response.ok) {
          this.getUser()
          this.showNameForm = false
        } else {
          this.showErrorModal = true
        }
      } catch (e) {
        console.error(e)
        this.showErrorModal = true
      }
    },

    async updateUserPassword() {
      try {
        const token = localStorage.getItem('token')

        const response = await this.$apiFetch(
          `${localStorage.getItem('apiUrl')}/private/api/client/user/update/password`,
          {
            method: 'POST',
            body: JSON.stringify(this.userUpdatePasswordRequest),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `${token}`,
            },
          }
        )

        if (response.ok) {
          this.userUpdatePasswordRequest = {
            currentPassword: '',
            newPassword: '',
          }
          this.confirmPassword = ''

          this.showPasswordForm = false
          this.sucessMessage = 'Password has been reset successfully'
          this.showSucessModal = true
        } else {
          this.userUpdatePasswordRequest = {
            currentPassword: '',
            newPassword: '',
          }
          this.confirmPassword = ''
          this.userUpdatePasswordRequestError = 'Password is incorrect'
        }
      } catch (e) {
        console.error(e)
        this.userUpdatePasswordRequest = {
          currentPassword: '',
          newPassword: '',
        }
        this.confirmPassword = ''
        this.userUpdatePasswordRequestError = 'Password is incorrect'
      }
    },

    async getUser() {
      try {
        const token = localStorage.getItem('token')
        this.loading = true

        const response = await this.$apiFetch(
          `${localStorage.getItem('apiUrl')}/private/api/client/user`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `${token}`,
            },
          }
        )

        if (response.ok) {
          var object = await response.json()
          this.userData = object

          var publisher = object.publisher.companyName
          localStorage.setItem('firstName', object.publisherUser.firstName)
          localStorage.setItem('lastName', object.publisherUser.lastName)
          localStorage.setItem(
            'sendContentNotifications',
            object.publisherUser.sendContentNotifications
          )
          localStorage.setItem(
            'sendWebhookNotifications',
            object.publisherUser.sendWebhookNotifications
          )

          localStorage.setItem('publisher', publisher)

          this.userDetails = {
            firstName: localStorage.getItem('firstName'),
            lastName: localStorage.getItem('lastName'),
            sendContentNotifications: localStorage.getItem('sendContentNotifications'),
            sendWebhookNotifications: localStorage.getItem('sendWebhookNotifications'),
          }

          window.dispatchEvent(
            new CustomEvent('foo-key-localstorage-changed', {
              detail: {
                storage: localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastName'),
              },
            })
          )
        }
      } catch (error) {
        return
      }
    },

    async handleInviteUser() {
      try {
        const token = localStorage.getItem('token')

        const response = await this.$apiFetch(
          `${localStorage.getItem('apiUrl')}/private/api/client/publisher/user/invite`,
          {
            method: 'POST',
            body: JSON.stringify(this.inviteUserRequest),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `${token}`,
            },
          }
        )

        if (response.ok) {
          this.showInviteUserForm = false
          this.inviteUserRequest = {
            email: '',
            admin: false,
          }
          toast.success('User has been invited successfully')
          this.getPublisherUsers(this.serverOptions.page - 1, this.serverOptions.rowsPerPage)
        } else {
          this.userInviteRequestFormError = 'This email already exists in our system'
        }
      } catch (e) {
        console.error(e)
        this.userInviteRequestFormError = 'This email already exists'
      }
    },

    memberInitials(member) {
      const f = (member.firstName || '').trim()
      const l = (member.lastName || '').trim()
      const initials = ((f[0] || '') + (l[0] || '')).toUpperCase()
      if (initials) return initials
      return (member.email || '?').charAt(0).toUpperCase()
    },
    statusLabel(status) {
      return { ACTIVE: 'Active', DEACTIVATED: 'Deactivated', INVITED: 'Invited' }[status] || status
    },
    statusVariant(status) {
      return { ACTIVE: 'success', DEACTIVATED: 'warning', INVITED: 'outline' }[status] || 'outline'
    },
    onFilterChange(filters) {
      this.filters = filters
      if (this.serverOptions.page !== 1) {
        // resetting the page triggers the serverOptions watch, which refetches
        this.serverOptions.page = 1
      } else {
        this.getPublisherUsers(0, this.serverOptions.rowsPerPage)
      }
    },

    async deactivateUser(userId) {
      await this.teamMemberAction(`publisher/user/${userId}/deactivate`)
    },
    async activateUser(userId) {
      await this.teamMemberAction(`publisher/user/${userId}/activate`)
    },
    confirmRevoke(member) {
      this.revokeTarget = member
      this.showRevokeConfirm = true
    },
    async handleRevokeConfirm() {
      const inviteId = this.revokeTarget?.id
      this.showRevokeConfirm = false
      if (!inviteId) return
      await this.teamMemberAction(`publisher/invite/${inviteId}/revoke`)
      this.revokeTarget = null
    },
    async teamMemberAction(path) {
      try {
        const token = localStorage.getItem('token')
        const response = await this.$apiFetch(
          `${localStorage.getItem('apiUrl')}/private/api/client/${path}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `${token}`,
            },
          }
        )
        if (response.ok) {
          this.getPublisherUsers(this.serverOptions.page - 1, this.serverOptions.rowsPerPage)
        } else {
          this.showErrorModal = true
        }
      } catch (e) {
        console.error(e)
        this.showErrorModal = true
      }
    },

    async getPublisherUsers(page, size) {
      this.loading = true
      this.error = false
      try {
        const token = localStorage.getItem('token')

        const params = new URLSearchParams()
        params.set('page', page ?? 0)
        params.set('size', size ?? this.serverOptions.rowsPerPage)
        for (const status of this.filters.status || []) {
          params.append('status', status)
        }

        const response = await this.$apiFetch(
          `${localStorage.getItem('apiUrl')}/private/api/client/publisher/team?${params.toString()}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `${token}`,
            },
          }
        )

        if (response.ok) {
          var object = await response.json()
          this.publisherUsers = object.content
          this.serverItemsLength = object.totalElements
        } else {
          this.error = true
        }
      } catch (e) {
        this.error = true
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style></style>
